import { defineComponent, computed, ref, watch } from 'vue';
import __vue_component__ from '../../../alerts/Alert.vue.js';
import __vue_component__$1 from '../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__$2 from '../../../inputs/TextInput/TextInput.vue.js';

var script = defineComponent({
    name: 'ManualEntryAlert',
    components: {
        Alert: __vue_component__,
        ButtonComponent: __vue_component__$1,
        TextInput: __vue_component__$2,
    },
    props: {
        isOpened: {
            type: Boolean,
            required: true,
        },
    },
    setup(_props, { emit, expose }) {
        const headerTitle = computed(() => 'Enter barcode manually');
        const barcode = ref('');
        const barcodeInputRef = ref(null);
        const isConfirmButtonDisabled = computed(() => !barcode.value);
        const closeAlert = () => {
            emit('close');
        };
        const confirm = () => {
            emit('confirm', barcode.value);
        };
        const resetBarcodeValue = () => {
            barcode.value = '';
        };
        expose({
            resetBarcodeValue,
        });
        watch(() => barcodeInputRef.value, () => {
            var _a, _b;
            const inputEl = (_b = (_a = barcodeInputRef.value) === null || _a === void 0 ? void 0 : _a.$el) === null || _b === void 0 ? void 0 : _b.querySelector('input');
            setTimeout(() => {
                var _a;
                (_a = inputEl === null || inputEl === void 0 ? void 0 : inputEl.focus) === null || _a === void 0 ? void 0 : _a.call(inputEl);
            }, 0);
        });
        return {
            barcode,
            barcodeInputRef,
            closeAlert,
            confirm,
            headerTitle,
            isConfirmButtonDisabled,
        };
    },
});

export { script as default };
